<template>
  <div>
    <Movementmenu />
    <v-container fluid class="grey lighten-4 pa-6">
      <!-- Dashboard Stats -->
      <v-row dense class="mb-4">
        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            color="indigo"
            dark
            hover
            @click="transference_personnelQueryAll"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">ผู้เสนอย้ายทั้งหมด</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ transference_personnelCount.sumAll || 0 }}
                  <small class="caption">ราย</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="indigo lighten-1">
                <v-icon size="30">mdi-account-group</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            color="success"
            dark
            hover
            @click="showSuccessPosition"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">รายการที่สำเร็จแล้ว</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ transference_personnelCount.sumsuc || 0 }}
                  <small class="caption">ราย</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="green lighten-1">
                <v-icon size="30">mdi-check-decagram</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg shadow-sm" color="blue" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">แนบไฟล์สมบูรณ์</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ transference_personnelCount.sumdoc || 0 }}
                  <small class="caption">ราย</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="blue lighten-1">
                <v-icon size="30">mdi-file-document-check</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            color="orange darken-2"
            dark
            hover
            @click="SearchCCdoc"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">แจ้งขอยกเลิกไฟล์</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ transference_personnelCount.sumcc || 0 }}
                  <small class="caption">ราย</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="orange darken-1">
                <v-icon size="30">mdi-file-cancel</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <!-- Additional Stats & Actions -->
        <v-col cols="12">
          <div class="d-flex flex-wrap align-center" style="gap: 10px;">
            <v-chip color="white" class="shadow-sm" label>
              <v-icon left color="teal">mdi-school</v-icon> เงื่อนไข 4 ปี:
              <strong class="ml-1">{{
                transference_personnelCount.conditions || 0
              }}</strong>
            </v-chip>
            <v-chip color="white" class="shadow-sm" label>
              <v-icon left color="brown">mdi-home-city</v-icon> ครูคืนถิ่น:
              <strong class="ml-1">{{
                transference_personnelCount.localDevs || 0
              }}</strong>
            </v-chip>
            <v-chip color="white" class="shadow-sm" label>
              <v-icon left color="deep-purple">mdi-map-marker-star</v-icon>
              จชต.:
              <strong class="ml-1">{{
                transference_personnelCount.sounths || 0
              }}</strong>
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn
              small
              rounded
              color="error"
              outlined
              @click="clearRecordDontSave"
            >
              <v-icon left>mdi-delete-sweep</v-icon> ลบรายการขยะ (ไม่บันทึก)
            </v-btn>
            <v-btn small rounded color="warning" outlined @click="optimizeData">
              <v-icon left>mdi-database-refresh</v-icon> จัดระเบียบฐานข้อมูล
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <!-- Main Data Table Card -->
      <base-material-card
        icon="mdi-account-details"
        title="จัดการข้อมูลการย้าย (สายการสอนและสนับสนุน)"
        color="primary"
        class="px-5 py-3"
      >
        <!-- Toolbar -->
        <v-card flat class="grey lighten-5 rounded-lg mb-4 pa-4">
          <v-row align="center">
            <v-col cols="12" md="8" class="d-flex flex-wrap" style="gap: 10px;">
              <v-btn small rounded color="success" @click="exportToExcel">
                <v-icon left>mdi-file-excel</v-icon> ส่งออก Excel
              </v-btn>

              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    rounded
                    color="info"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left>mdi-printer</v-icon> พิมพ์รายงาน
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    link
                    :href="
                      `#/admin/print_assess1420/${periods.period_times}/${periods.period_year}`
                    "
                    target="_blank"
                  >
                    <v-list-item-title
                      >แบบประเมินคะแนน 1.4 (1)</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item
                    link
                    :href="
                      `#/admin/print_assess1420detail/${periods.period_times}/${periods.period_year}`
                    "
                    target="_blank"
                  >
                    <v-list-item-title
                      >แบบประเมินคะแนน 1.4 (2)</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-btn
                small
                rounded
                color="warning"
                @click="Searchtemporary"
                outlined
              >
                <v-icon left>mdi-content-save-alert</v-icon> กรอง: ยังไม่บันทึก
              </v-btn>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="ค้นหา (ชื่อ, สังกัด, จังหวัด, เลขที่...)"
                outlined
                dense
                rounded
                hide-details
                class="bg-white"
                clearable
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                label="แสดง/ซ่อน คอลัมน์"
                multiple
                outlined
                dense
                return-object
                small-chips
                hide-details
                class="bg-white"
              >
                <template v-slot:selection="{ index }">
                  <span v-if="index === 0" class="caption grey--text">
                    เลือกคอลัมน์ที่จะแสดง ({{ selectedHeaders.length }}
                    Selected)
                  </span>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-card>

        <!-- Data Table -->
        <v-data-table
          :headers="showHeaders"
          :items="transference_personnels"
          :search="search"
          :loading="loading"
          item-key="tid_ref"
          class="elevation-0 custom-table"
          :items-per-page="15"
          :footer-props="{
            'items-per-page-options': [10, 15, 25, 50, 100, -1],
            'items-per-page-text': 'แถวต่อหน้า:'
          }"
        >
          <!-- Status Badge -->
          <template v-slot:item.transfer_status="{ item }">
            <v-chip
              small
              :color="item.transfer_status === 'save' ? 'success' : 'warning'"
              dark
              label
              @click="
                item.transfer_status !== 'save'
                  ? changeStatus(item.tid_ref)
                  : null
              "
              :style="item.transfer_status !== 'save' ? 'cursor: pointer;' : ''"
            >
              <v-icon left small>
                {{
                  item.transfer_status === "save"
                    ? "mdi-check-circle"
                    : "mdi-clock-alert"
                }}
              </v-icon>
              {{
                item.transfer_status === "save" ? "บันทึกแล้ว" : "ยังไม่บันทึก"
              }}
            </v-chip>
          </template>

          <!-- File Upload Status -->
          <template v-slot:item.updateFileDoc="{ item }">
            <v-icon v-if="item.documentsLinkfile" color="success" size="20">
              mdi-check-circle
            </v-icon>
            <v-btn
              v-else
              x-small
              color="warning"
              outlined
              @click="updateFileDoc(item.tid_ref)"
            >
              <v-icon left x-small>mdi-paperclip</v-icon>
              แนบไฟล์
            </v-btn>
          </template>

          <!-- Director Comment -->
          <template v-slot:item.comment_dr_c="{ item }">
            <v-chip
              x-small
              :color="getCommentColor(item.comment_dr_c)"
              dark
              @click.stop="comment_idPosition(item.tid_ref)"
              class="cursor-pointer"
            >
              {{ getCommentText(item.comment_dr_c) }}
            </v-chip>
          </template>

          <!-- Provincial Committee Comment -->
          <template v-slot:item.tp_comment_dr_stb="{ item }">
            <v-chip
              x-small
              :color="getCommentColor(item.tp_comment_dr_stb)"
              dark
              @click.stop="tp_comment_dr_stbPosition(item.tid_ref)"
              class="cursor-pointer"
            >
              {{ getCommentText(item.tp_comment_dr_stb) }}
            </v-chip>
          </template>

          <!-- Document Link -->
          <template v-slot:item.documentsLinkfile="{ item }">
            <div
              v-if="item.documentsLinkfile"
              class="d-flex align-center justify-center"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    color="primary"
                    @click="viewdocumentsLinkfile(item.documentsLinkfile)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-file-eye</v-icon>
                  </v-btn>
                </template>
                <span>ดูไฟล์แนบ</span>
              </v-tooltip>
              <v-icon
                v-if="item.ccDocumentFile === 'cc'"
                color="red"
                small
                class="ml-1"
              >
                mdi-alert-circle
              </v-icon>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="red lighten-2"
                    small
                    class="ml-1 pointer"
                    @click.stop="CancelFilePDF(item.tid_ref)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-close-circle
                  </v-icon>
                </template>
                <span>ลบไฟล์</span>
              </v-tooltip>
            </div>
            <span v-else class="grey--text caption">-</span>
          </template>

          <!-- Province Score File -->
          <template v-slot:item.tpvecprovince_scoreFile="{ item }">
            <div
              v-if="item.tpvecprovince_scoreFile"
              class="d-flex align-center justify-center"
            >
              <v-btn
                icon
                small
                color="teal"
                :href="'/HRvecfiles/' + item.tpvecprovince_scoreFile"
                target="_blank"
              >
                <v-icon>mdi-file-percent</v-icon>
              </v-btn>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="red lighten-2"
                    small
                    class="ml-1 pointer"
                    @click.stop="CancelFilePDFProvince(item.tid_ref)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-close-circle
                  </v-icon>
                </template>
                <span>ลบไฟล์คะแนน</span>
              </v-tooltip>
            </div>
            <span v-else class="grey--text caption">-</span>
          </template>

          <!-- Normal Transfer Action -->
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.succ_college >= 1"
                  icon
                  small
                  color="red"
                  @click.stop="deletePosition(item.id_ref)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-delete-restore</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  icon
                  small
                  color="blue"
                  @click.stop="select_idPosition(item.tid_ref)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-account-arrow-right</v-icon>
                </v-btn>
              </template>
              <span>{{
                item.succ_college >= 1 ? "ยกเลิกการย้าย" : "จัดสรรตำแหน่ง"
              }}</span>
            </v-tooltip>
          </template>

          <!-- Cut Transfer Action -->
          <template v-slot:item.MoveCut="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.succ_college >= 1"
                  icon
                  small
                  color="red"
                  @click.stop="deletePosition(item.id_ref)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-delete-restore</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  icon
                  small
                  color="purple"
                  @click.stop="select_idPositionMoveCut(item.tid_ref)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-content-cut</v-icon>
                </v-btn>
              </template>
              <span>{{
                item.succ_college >= 1 ? "ยกเลิกการย้าย" : "ตัดโอนตำแหน่ง"
              }}</span>
            </v-tooltip>
          </template>

          <!-- Delete Record -->
          <template v-slot:item.del="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="grey"
                  @click.stop="deletetpteach(item.id_tfp)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>ลบรายการ</span>
            </v-tooltip>
          </template>

          <!-- Score Input -->
          <template v-slot:item.score_1420="{ item }">
            <v-text-field
              v-model="item.score_1420"
              dense
              hide-details
              outlined
              style="width: 80px"
              type="number"
              min="0"
              max="100"
              @change="updateScore1420(item.id_tfp, item.score_1420)"
              @blur="updateScore1420(item.id_tfp, item.score_1420)"
            ></v-text-field>
          </template>

          <!-- Receipt Status -->
          <template v-slot:item.actionReceipt="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-if="item.tp14receipt === 'success'"
                  color="success"
                  @click="actionReceiptUpdate(item.id_tfp)"
                  class="cursor-pointer"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-checkbox-marked-circle
                </v-icon>
                <v-icon
                  v-else
                  color="grey lighten-1"
                  @click="actionReceipts(item.id_tfp)"
                  class="cursor-pointer"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-checkbox-blank-circle-outline
                </v-icon>
              </template>
              <span>{{
                item.tp14receipt === "success"
                  ? "ยกเลิกสถานะรับเรื่อง"
                  : "ทำเครื่องหมายว่ารับเรื่อง"
              }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </base-material-card>

      <!-- ===== DIALOGS ===== -->

      <!-- Normal Transfer Dialog -->
      <v-dialog v-model="positiondialog" persistent max-width="900px">
        <v-card class="rounded-lg">
          <v-toolbar color="primary" dark flat>
            <v-icon left>mdi-account-switch</v-icon>
            <v-toolbar-title>เลือกตำแหน่งปลายทาง (ปกติ)</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="positiondialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pa-4">
            <v-row>
              <v-col cols="12" md="6">
                <v-card outlined class="pa-3 fill-height">
                  <div class="subtitle-2 primary--text mb-2">
                    ข้อมูลผู้ขอย้าย
                  </div>
                  <div class="text-h6">
                    {{ transference_personnels_id_ref.personnel_name }}
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div class="caption mb-1">
                    <v-icon small color="grey darken-1"
                      >mdi-badge-account</v-icon
                    >
                    ตำแหน่งปัจจุบัน:
                    <strong>{{
                      transference_personnels_id_ref.id_position
                    }}</strong>
                  </div>
                  <div class="caption">
                    <v-icon small color="grey darken-1"
                      >mdi-office-building</v-icon
                    >
                    สังกัด:
                    <strong>{{
                      transference_personnels_id_ref.college_name
                    }}</strong>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card outlined class="pa-3 fill-height bg-light-blue">
                  <div class="subtitle-2 blue--text text--darken-3 mb-2">
                    เลือกปลายทาง
                  </div>
                  <v-autocomplete
                    :items="colleges"
                    item-text="college_name"
                    item-value="college_code"
                    v-model="updatepositions.ctscollege_code"
                    label="วิทยาลัยปลายทาง"
                    outlined
                    dense
                    bg-color="white"
                    prepend-inner-icon="mdi-school"
                    @change="man_powerQuery()"
                    :rules="[v => !!v || 'กรุณาเลือกวิทยาลัย']"
                  ></v-autocomplete>
                  <v-autocomplete
                    :items="man_powers"
                    item-text="college_position_case"
                    item-value="id_position"
                    label="เลขที่ตำแหน่งว่าง"
                    v-model="updatepositions.ctsid_position"
                    outlined
                    dense
                    bg-color="white"
                    prepend-inner-icon="mdi-numeric"
                    :disabled="!updatepositions.ctscollege_code"
                    :rules="[v => !!v || 'กรุณาเลือกตำแหน่ง']"
                    :loading="loadingPositions"
                  ></v-autocomplete>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="positiondialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="success"
              depressed
              @click="updatepositionSubmit"
              :disabled="
                !updatepositions.ctscollege_code ||
                  !updatepositions.ctsid_position
              "
            >
              <v-icon left>mdi-content-save</v-icon>
              บันทึกการจัดสรร
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Cut Transfer Dialog -->
      <v-dialog v-model="positionMoveCutdialog" persistent max-width="800px">
        <v-card class="rounded-lg">
          <v-toolbar color="purple" dark flat>
            <v-icon left>mdi-content-cut</v-icon>
            <v-toolbar-title>ตัดโอนตำแหน่ง</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="positionMoveCutdialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pa-4">
            <v-alert type="info" text dense border="left" class="mb-4">
              <div class="font-weight-bold">การตัดโอนตำแหน่ง:</div>
              ตำแหน่งและเลขที่ตำแหน่งจะติดตัวผู้ขอย้ายไปสังกัดใหม่
            </v-alert>

            <div class="mb-3">
              <div class="subtitle-2 grey--text text--darken-2">
                ข้อมูลผู้ขอย้าย
              </div>
              <div class="text-h6">
                {{ transference_personnels_id_ref.personnel_name }}
              </div>
              <div class="caption">
                ตำแหน่งที่จะตัดโอน:
                {{ transference_personnels_id_ref.id_position }}
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <v-autocomplete
              :items="colleges"
              item-text="college_name"
              item-value="college_code"
              v-model="updatepositions.ctscollege_code"
              label="วิทยาลัยปลายทาง"
              outlined
              dense
              prepend-inner-icon="mdi-school"
              :rules="[v => !!v || 'กรุณาเลือกวิทยาลัย']"
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="positionMoveCutdialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="purple"
              dark
              depressed
              @click="updatepositionMoveCutSubmit"
              :disabled="!updatepositions.ctscollege_code"
            >
              <v-icon left>mdi-content-save</v-icon>
              บันทึกตัดโอน
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Cancel Transfer Dialog -->
      <v-dialog v-model="canceldialog" persistent max-width="500px">
        <v-card class="rounded-lg">
          <v-card-title class="headline warning--text">
            <v-icon left color="warning">mdi-alert</v-icon>
            ยืนยันการยกเลิก
          </v-card-title>
          <v-card-text class="pt-4">
            <v-alert type="warning" text border="left" class="mb-3">
              คุณต้องการยกเลิกรายการย้ายของ
              <strong>{{
                transference_personnels_id_ref.personnel_name
              }}</strong>
              ใช่หรือไม่?
            </v-alert>
            <div class="caption grey--text">
              * การยกเลิกจะคืนตำแหน่งกลับไปยังสถานศึกษาเดิมและลบการจัดสรรปลายทาง
            </div>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="canceldialog = false">
              <v-icon left>mdi-close</v-icon>
              ปิด
            </v-btn>
            <v-btn color="warning" depressed @click="cancelSubmit">
              <v-icon left>mdi-check</v-icon>
              ยืนยันการยกเลิก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Director Comment Dialog -->
      <v-dialog v-model="commentDrdialog" persistent max-width="700px">
        <v-card class="rounded-lg">
          <v-toolbar color="amber darken-2" dark flat dense>
            <v-icon left>mdi-comment-account</v-icon>
            <v-toolbar-title>ความเห็นผู้อำนวยการวิทยาลัย</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="commentDrdialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <div class="mb-3">
              <div class="subtitle-2 grey--text text--darken-2">ผู้ขอย้าย</div>
              <div class="text-h6">
                {{ transference_personnels_id_ref.personnel_name }}
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="subtitle-2 mb-2">ความเห็น</div>
            <v-radio-group
              v-model="transference_personnels_id_ref.comment_dr_c"
              row
              class="justify-center mt-0"
            >
              <v-radio label="เห็นควร" value="approp" color="success">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="success">mdi-check-circle</v-icon>
                    <span>เห็นควร</span>
                  </div>
                </template>
              </v-radio>
              <v-radio label="ไม่เห็นควร" value="inapprop" color="warning">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="warning">mdi-alert-circle</v-icon>
                    <span>ไม่เห็นควร</span>
                  </div>
                </template>
              </v-radio>
              <v-radio label="ระงับย้าย" value="suspend" color="error">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="error">mdi-cancel</v-icon>
                    <span>ระงับย้าย</span>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>

            <v-textarea
              v-if="transference_personnels_id_ref.comment_dr_c !== 'approp'"
              label="เหตุผล (กรณีไม่เห็นควร/ระงับ)"
              v-model="transference_personnels_id_ref.detail_comment"
              outlined
              dense
              rows="3"
              counter
              :rules="[
                v =>
                  transference_personnels_id_ref.comment_dr_c === 'approp' ||
                  !!v ||
                  'กรุณาระบุเหตุผล'
              ]"
            ></v-textarea>

            <v-divider class="my-4"></v-divider>

            <div class="subtitle-2 mb-2">สถานะเอกสาร</div>
            <v-radio-group
              v-model="transference_personnels_id_ref.status_document"
              row
              dense
              class="mt-0"
            >
              <v-radio label="สมบูรณ์" value="complete" color="success">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="success" small>mdi-file-check</v-icon>
                    <span>สมบูรณ์</span>
                  </div>
                </template>
              </v-radio>
              <v-radio label="ไม่สมบูรณ์" value="incomplete" color="warning">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="warning" small>mdi-file-alert</v-icon>
                    <span>ไม่สมบูรณ์</span>
                  </div>
                </template>
              </v-radio>
              <v-radio label="ไม่ส่ง" value="do_not" color="error">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="error" small>mdi-file-remove</v-icon>
                    <span>ไม่ส่ง</span>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="commentDrdialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="amber darken-2"
              dark
              depressed
              @click="updatecommentSubmit"
              :disabled="
                !transference_personnels_id_ref.comment_dr_c ||
                  !transference_personnels_id_ref.status_document
              "
            >
              <v-icon left>mdi-content-save</v-icon>
              บันทึกความเห็น
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Provincial Committee Comment Dialog -->
      <v-dialog v-model="comment_stb_Drdialog" persistent max-width="700px">
        <v-card class="rounded-lg">
          <v-toolbar color="teal darken-1" dark flat dense>
            <v-icon left>mdi-account-group</v-icon>
            <v-toolbar-title
              >ความเห็นคณะกรรมการศึกษาธิการจังหวัด
              (กศจ./อ.ก.ค.ศ.)</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon @click="comment_stb_Drdialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <div class="mb-3">
              <div class="subtitle-2 grey--text text--darken-2">ผู้ขอย้าย</div>
              <div class="text-h6">
                {{ transference_personnels_id_ref.personnel_name }}
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="subtitle-2 mb-2">ความเห็นคณะกรรมการ</div>
            <v-radio-group
              v-model="transference_personnels_id_ref.tp_comment_dr_stb"
              row
              class="justify-center mt-0"
            >
              <v-radio label="เห็นควร" value="approp" color="success">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="success">mdi-check-decagram</v-icon>
                    <span>เห็นควร</span>
                  </div>
                </template>
              </v-radio>
              <v-radio label="ไม่เห็นควร" value="inapprop" color="warning">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="warning">mdi-alert-decagram</v-icon>
                    <span>ไม่เห็นควร</span>
                  </div>
                </template>
              </v-radio>
              <v-radio label="ระงับ/ชะลอ" value="suspend" color="error">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="error">mdi-cancel</v-icon>
                    <span>ระงับ/ชะลอ</span>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="comment_stb_Drdialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="teal darken-1"
              dark
              depressed
              @click="updateCommentStbSubmit"
              :disabled="!transference_personnels_id_ref.tp_comment_dr_stb"
            >
              <v-icon left>mdi-content-save</v-icon>
              บันทึกผลการพิจารณา
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- File Upload Dialog -->
      <v-dialog v-model="updateFileDocdialog" persistent max-width="600px">
        <v-card class="rounded-lg">
          <v-toolbar color="info" dark flat dense>
            <v-icon left>mdi-file-upload</v-icon>
            <v-toolbar-title>แนบไฟล์เอกสาร</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="updateFileDocdialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <v-alert type="info" text dense border="left" class="mb-3">
              <div class="caption">
                รองรับไฟล์ PDF เท่านั้น | ขนาดไม่เกิน 10 MB
              </div>
            </v-alert>

            <v-file-input
              v-model="documentsLinkfiles"
              label="แบบคำร้องขอย้าย (.pdf)"
              accept=".pdf"
              outlined
              dense
              prepend-icon="mdi-file-pdf-box"
              :rules="fileRules"
              show-size
              counter
            >
              <template v-slot:selection="{ text }">
                <v-chip small color="primary" text-color="white">
                  <v-icon left small>mdi-file-pdf-box</v-icon>
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>

            <v-file-input
              v-model="documentsLinkfiles3"
              label="เอกสารตัวชี้วัด 1.4 (.pdf)"
              accept=".pdf"
              outlined
              dense
              prepend-icon="mdi-file-chart"
              :rules="fileRules"
              show-size
              counter
            >
              <template v-slot:selection="{ text }">
                <v-chip small color="teal" text-color="white">
                  <v-icon left small>mdi-file-chart</v-icon>
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="updateFileDocdialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="info"
              depressed
              @click="updateFileDocSubmit"
              :loading="uploadingFile"
            >
              <v-icon left>mdi-cloud-upload</v-icon>
              อัปโหลดไฟล์
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- PDF Viewer Dialog -->
      <v-dialog
        v-model="pdfdocumentsLinkfileDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="grey darken-3">
            <v-btn icon dark @click="pdfdocumentsLinkfileDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>ตัวอย่างเอกสารแนบ</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark :href="`/HRvecfiles/${pdf_files}`" download>
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </v-toolbar>
          <div style="height: 100vh; background: #525659;">
            <embed
              :src="`/HRvecfiles/${pdf_files}#toolbar=1`"
              width="100%"
              height="100%"
              type="application/pdf"
            />
          </div>
        </v-card>
      </v-dialog>

      <!-- Password Confirmation Dialog (for Delete Operations) -->
      <v-dialog v-model="passwordDialog" persistent max-width="450px">
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text">
            <v-icon left color="error">mdi-lock-alert</v-icon>
            ยืนยันตัวตนด้วยรหัสผ่าน
          </v-card-title>
          <v-card-text class="pt-4">
            <v-alert type="error" text border="left" class="mb-3">
              <div class="font-weight-bold">
                การดำเนินการนี้ต้องการรหัสยืนยัน!
              </div>
              <div class="caption">
                กรุณาระบุรหัสผ่านเพื่อยืนยันการ{{ currentDeleteAction }}
              </div>
            </v-alert>

            <v-text-field
              v-model="passwordInput"
              label="รหัสผ่านยืนยัน"
              :type="showPassword ? 'text' : 'password'"
              outlined
              dense
              prepend-inner-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              @keyup.enter="verifyPassword"
              :error-messages="passwordError"
              autofocus
              counter
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="cancelPasswordVerification">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="error"
              depressed
              @click="verifyPassword"
              :disabled="!passwordInput"
            >
              <v-icon left>mdi-check</v-icon>
              ยืนยัน
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Snackbar Notification -->
      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        top
        right
        rounded="pill"
        :timeout="3000"
      >
        <v-icon left color="white">{{ snackbar.icon }}</v-icon>
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx";

export default {
  name: "TransferencePersonnelManagement",
  components: { Movementmenu },

  data() {
    return {
      // API Configuration
      ApiKey: "HRvec2021",
      ADMIN_PASSWORD: "0612698358", // รหัสผ่านสำหรับการลบ

      // Loading States
      loading: false,
      loadingPositions: false,
      uploadingFile: false,

      // Search & Filter
      search: "",

      // Dialog Controls
      positiondialog: false,
      positionMoveCutdialog: false,
      canceldialog: false,
      commentDrdialog: false,
      updateFileDocdialog: false,
      comment_stb_Drdialog: false,
      pdfdocumentsLinkfileDialog: false,
      passwordDialog: false,

      // Password Verification
      passwordInput: "",
      passwordError: "",
      showPassword: false,
      currentDeleteAction: "",
      pendingDeleteCallback: null,

      // Data Collections
      transference_personnels: [],
      transference_personnelCount: {
        sumAll: 0,
        sumcc: 0,
        sumsuc: 0,
        sumdoc: 0,
        conditions: 0,
        localDevs: 0,
        sounths: 0
      },
      transference_personnels_id_ref: {},
      man_powers: [],
      colleges: [],
      periods: {},

      // Form Inputs
      updatepositions: {
        ctscollege_code: null,
        ctsid_position: null
      },
      documentsLinkfiles: null,
      documentsLinkfiles3: null,
      pdf_files: null,

      // UI Configuration
      snackbar: {
        show: false,
        color: "info",
        icon: "mdi-information",
        text: ""
      },

      // Table Headers
      selectedHeaders: [],
      headersMap: [
        {
          text: "ย้ายปกติ",
          value: "actions",
          align: "center",
          sortable: false,
          width: "100px"
        },
        {
          text: "ตัดโอน",
          value: "MoveCut",
          align: "center",
          sortable: false,
          width: "100px"
        },
        {
          text: "สถานะปลายทาง",
          value: "succ_college",
          align: "center",
          width: "120px"
        },
        {
          text: "วิทยาลัยปลายทาง",
          value: "college_name_suss",
          align: "left",
          width: "200px"
        },
        {
          text: "เลขที่ใหม่",
          value: "id_position_new",
          align: "center",
          width: "120px"
        },
        {
          text: "รหัสบัตรประชาชน",
          value: "id_card",
          align: "left",
          width: "150px"
        },
        {
          text: "ผู้ขอย้าย",
          value: "personnel_name",
          align: "left",
          width: "200px"
        },
        {
          text: "สถานะบันทึก",
          value: "transfer_status",
          align: "center",
          width: "140px"
        },
        {
          text: "สังกัดปัจจุบัน",
          value: "college_name",
          align: "left",
          width: "200px"
        },
        {
          text: "ไฟล์แนบ",
          value: "updateFileDoc",
          align: "center",
          width: "100px"
        },
        {
          text: "ความเห็น ผอ.วิทฯ",
          value: "comment_dr_c",
          align: "center",
          width: "120px"
        },
        {
          text: "ความเห็น สอจ.",
          value: "tp_comment_dr_stb",
          align: "center",
          width: "120px"
        },
        {
          text: "เอกสารคำร้อง",
          value: "documentsLinkfile",
          align: "center",
          width: "120px"
        },
        {
          text: "คะแนน สอจ.",
          value: "tpvecprovince_scoreFile",
          align: "center",
          width: "120px"
        },
        {
          text: "คะแนน กก.",
          value: "score_1420",
          align: "center",
          width: "100px"
        },
        {
          text: "รับเรื่อง",
          value: "actionReceipt",
          align: "center",
          width: "100px"
        },
        {
          text: "ยกเลิกรายการ",
          value: "del",
          align: "center",
          sortable: false,
          width: "120px"
        }
      ],
      headers: [],

      // File Validation Rules
      fileRules: [
        value => !value || value.size < 10485760 || "ขนาดไฟล์ต้องไม่เกิน 10 MB",
        value =>
          !value || value.type === "application/pdf" || "รองรับเฉพาะไฟล์ PDF"
      ]
    };
  },

  computed: {
    showHeaders() {
      return this.selectedHeaders;
    },
    time_stamp() {
      return Date.now();
    }
  },

  async created() {
    this.headers = this.headersMap;
    this.selectedHeaders = this.headers; // แสดงทุกคอลัมน์ตั้งต้น
  },

  async mounted() {
    await this.fetchInitialData();
  },

  methods: {
    // ===== INITIALIZATION =====
    async fetchInitialData() {
      this.loading = true;
      try {
        // โหลดข้อมูลงวดที่เปิดใช้งาน
        let resPeriod = await this.$http.post("period.php", {
          ApiKey: this.ApiKey,
          period_enable_process: "1",
          period_id: "301"
        });
        this.periods = resPeriod.data;

        // โหลดรายชื่อวิทยาลัย
        let resCol = await this.$http.post("college.php", {
          ApiKey: this.ApiKey
        });
        this.colleges = resCol.data;

        // โหลดข้อมูลบุคลากรที่ขอย้าย
        await this.transference_personnelQueryAll();
      } catch (error) {
        console.error("Error fetching initial data:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการโหลดข้อมูล", "error");
      } finally {
        this.loading = false;
      }
    },

    // ===== DATA QUERIES =====
    async transference_personnelQueryAll() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          type_move: "nm"
        });

        this.transference_personnels = res.data || [];
        this.calculateStats();
      } catch (error) {
        console.error("Error querying personnel:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการดึงข้อมูล", "error");
      } finally {
        this.loading = false;
      }
    },

    calculateStats() {
      let data = this.transference_personnels;
      this.transference_personnelCount = {
        sumAll: data.length,
        sumcc: data.filter(x => x.ccDocumentFile === "cc").length,
        sumsuc: data.filter(x => x.transfer_status === "save").length,
        sumdoc: data.filter(x => String(x.documentsLinkfile || "").length > 6)
          .length,
        conditions: data.filter(x => x.type_personnel === "select").length,
        localDevs: data.filter(x => x.type_personnel === "local_dev").length,
        sounths: data.filter(
          x => x.province_difficulty == "1" || x.prefecture_difficulty == "1"
        ).length
      };
    },

    async showSuccessPosition() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          type_move: "nm",
          success_s: "ok"
        });
        this.transference_personnels = res.data || [];
        this.calculateStats();
        this.showSnackbar("แสดงรายการที่สำเร็จแล้ว", "success");
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.loading = false;
      }
    },

    async Searchtemporary() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          transfer_status: "temporary"
        });
        this.transference_personnels = res.data || [];
        this.calculateStats();
        this.showSnackbar("แสดงรายการที่ยังไม่บันทึก", "info");
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.loading = false;
      }
    },

    async SearchCCdoc() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          type_move: "nm",
          ccDocumentFile: "cc"
        });
        this.transference_personnels = res.data || [];
        this.calculateStats();
        this.showSnackbar(
          `พบรายการแจ้งยกเลิก ${this.transference_personnels.length} รายการ`,
          "warning"
        );
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.loading = false;
      }
    },

    async fetchPersonDetail(tid_ref) {
      try {
        let res = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: tid_ref
        });
        this.transference_personnels_id_ref = res.data || {};
      } catch (error) {
        console.error("Error fetching person detail:", error);
        this.showSnackbar("ไม่สามารถโหลดข้อมูลบุคคลได้", "error");
      }
    },

    // ===== TRANSFER POSITION MANAGEMENT =====
    async select_idPosition(tid_ref) {
      await this.fetchPersonDetail(tid_ref);
      this.updatepositions = {
        ctscollege_code: null,
        ctsid_position: null
      };
      this.man_powers = [];
      this.positiondialog = true;
    },

    async select_idPositionMoveCut(tid_ref) {
      await this.fetchPersonDetail(tid_ref);
      this.updatepositions = {
        ctscollege_code: null,
        ctsid_position: null
      };
      this.positionMoveCutdialog = true;
    },

    async man_powerQuery() {
      if (!this.updatepositions.ctscollege_code) return;

      this.loadingPositions = true;
      try {
        let res = await this.$http.post("man_power_process.php", {
          ApiKey: this.ApiKey,
          college_code: this.updatepositions.ctscollege_code
        });
        this.man_powers = res.data || [];

        if (this.man_powers.length === 0) {
          this.showSnackbar("ไม่พบตำแหน่งว่างในวิทยาลัยนี้", "warning");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการค้นหาตำแหน่ง", "error");
      } finally {
        this.loadingPositions = false;
      }
    },

    async updatepositionSubmit() {
      const person = this.transference_personnels_id_ref;
      const form = this.updatepositions;

      if (!form.ctscollege_code || !form.ctsid_position) {
        this.showSnackbar("กรุณาเลือกวิทยาลัยและตำแหน่งปลายทาง", "warning");
        return;
      }

      this.loading = true;
      try {
        // 1. Payload สำหรับบันทึกการจัดสรร
        let payload = {
          ApiKey: this.ApiKey,
          ctsid_ref: person.tid_ref,
          ctstime_s: person.time_ss,
          ctsyear_s: person.year_ss,
          ctsid_postion_old: person.id_position,
          ctscollege_code_old: person.college_code,
          ctsid_card: person.id_card,
          ctsname_position: "ครู",
          ctsstatus_select: "demand",
          ctsid_position: form.ctsid_position,
          ctscollege_code: form.ctscollege_code
        };

        // 2. Payload สำหรับคืนตำแหน่งเก่า
        let returnPayload = {
          ApiKey: this.ApiKey,
          college_code: person.college_code,
          id_position: person.id_position,
          position: "ครู",
          case_vacancy: `ย้ายรอบ-${person.time_ss}/${person.year_ss}`
        };

        // 3. ดำเนินการทั้ง 3 ขั้นตอน
        let [res1, res2, res3] = await Promise.all([
          this.$http.post("man_power.insert.php", returnPayload), // คืนตำแหน่งเก่า
          this.$http.post("man_power.update_process.php", {
            ApiKey: this.ApiKey,
            id_position: form.ctsid_position,
            status_booking: person.id_card
          }), // จองตำแหน่งใหม่
          this.$http.post("conditons_transfer_success.insert.php", payload) // บันทึกการย้าย
        ]);

        if (res1.data.status && res2.data.status && res3.data.status) {
          this.showSnackbar("บันทึกการจัดสรรเรียบร้อย", "success");
          this.positiondialog = false;
          await this.transference_personnelQueryAll();
        } else {
          throw new Error("บางขั้นตอนล้มเหลว");
        }
      } catch (error) {
        console.error("Error in updatepositionSubmit:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่", "error");
      } finally {
        this.loading = false;
      }
    },

    async updatepositionMoveCutSubmit() {
      const person = this.transference_personnels_id_ref;
      const form = this.updatepositions;

      if (!form.ctscollege_code) {
        this.showSnackbar("กรุณาเลือกวิทยาลัยปลายทาง", "warning");
        return;
      }

      this.loading = true;
      try {
        let payload = {
          ApiKey: this.ApiKey,
          ctsid_ref: person.tid_ref,
          ctstime_s: person.time_ss,
          ctsyear_s: person.year_ss,
          ctscollege_code_old: person.college_code,
          ctsid_postion_old: person.id_position,
          ctsid_position: person.id_position, // ตำแหน่งเดียวกัน
          ctsid_card: person.id_card,
          ctsname_position: "ครู",
          ctsstatus_select: "transfer", // Flag สำหรับการตัดโอน
          ctscollege_code: form.ctscollege_code
        };

        let res = await this.$http.post(
          "conditons_transfer_success.insert.php",
          payload
        );

        if (res.data.status) {
          this.showSnackbar("บันทึกการตัดโอนเรียบร้อย", "success");
          this.positionMoveCutdialog = false;
          await this.transference_personnelQueryAll();
        } else {
          throw new Error("การบันทึกล้มเหลว");
        }
      } catch (error) {
        console.error("Error in updatepositionMoveCutSubmit:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึก", "error");
      } finally {
        this.loading = false;
      }
    },

    async deletePosition(id_ref) {
      await this.fetchPersonDetail(id_ref);

      try {
        let resCts = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctsid_ref: id_ref
        });
        this.transference_personnels_id_ref.ctsData = resCts.data;
        this.canceldialog = true;
      } catch (error) {
        this.showSnackbar("ไม่สามารถโหลดข้อมูลการย้ายได้", "error");
      }
    },

    async cancelSubmit() {
      const ctsData = this.transference_personnels_id_ref.ctsData;

      if (!ctsData || !ctsData.id_cts) {
        this.showSnackbar("ไม่พบข้อมูลการย้าย", "error");
        return;
      }

      this.loading = true;
      try {
        // 1. ปลดล็อคตำแหน่งใหม่
        await this.$http.post("man_power.update_process.php", {
          ApiKey: this.ApiKey,
          status_booking: "",
          id_position: ctsData.ctsid_position
        });

        // 2. ลบตำแหน่งที่คืนกลับ (ถ้ามี)
        if (ctsData.ctsid_postion_old) {
          await this.$http.post("man_power.delete.php", {
            ApiKey: this.ApiKey,
            id_position: ctsData.ctsid_postion_old
          });
        }

        // 3. ลบบันทึกการย้าย
        let res = await this.$http.post(
          "conditons_transfer_success.delete.php",
          {
            ApiKey: this.ApiKey,
            id_cts: ctsData.id_cts
          }
        );

        if (res.data.status) {
          this.showSnackbar("ยกเลิกรายการเรียบร้อย", "success");
          this.canceldialog = false;
          await this.transference_personnelQueryAll();
        } else {
          throw new Error("การยกเลิกล้มเหลว");
        }
      } catch (error) {
        console.error("Error in cancelSubmit:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการยกเลิก", "error");
      } finally {
        this.loading = false;
      }
    },

    // ===== COMMENT & STATUS MANAGEMENT =====
    async comment_idPosition(tid_ref) {
      await this.fetchPersonDetail(tid_ref);
      this.commentDrdialog = true;
    },

    async updatecommentSubmit() {
      const person = this.transference_personnels_id_ref;

      if (!person.comment_dr_c || !person.status_document) {
        this.showSnackbar("กรุณาระบุข้อมูลให้ครบถ้วน", "warning");
        return;
      }

      if (person.comment_dr_c !== "approp" && !person.detail_comment) {
        this.showSnackbar("กรุณาระบุเหตุผล", "warning");
        return;
      }

      this.loading = true;
      try {
        let payload = {
          ApiKey: this.ApiKey,
          id_tfp: person.id_tfp,
          comment_dr_c: person.comment_dr_c,
          detail_comment: person.detail_comment || "",
          status_document: person.status_document
        };

        let res = await this.$http.post(
          "transference_personnel.update.php",
          payload
        );

        if (res.data.status) {
          this.showSnackbar("บันทึกความเห็นเรียบร้อย", "success");
          this.commentDrdialog = false;
          await this.transference_personnelQueryAll();
        } else {
          throw new Error("การบันทึกล้มเหลว");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึก", "error");
      } finally {
        this.loading = false;
      }
    },

    async tp_comment_dr_stbPosition(tid_ref) {
      await this.fetchPersonDetail(tid_ref);
      this.comment_stb_Drdialog = true;
    },

    async updateCommentStbSubmit() {
      const person = this.transference_personnels_id_ref;

      if (!person.tp_comment_dr_stb) {
        this.showSnackbar("กรุณาเลือกความเห็น", "warning");
        return;
      }

      this.loading = true;
      try {
        let payload = {
          ApiKey: this.ApiKey,
          id_tfp: person.id_tfp,
          tp_comment_dr_stb: person.tp_comment_dr_stb
        };

        let res = await this.$http.post(
          "transference_personnel.update.php",
          payload
        );

        if (res.data.status) {
          this.showSnackbar("บันทึกความเห็น สอจ. เรียบร้อย", "success");
          this.comment_stb_Drdialog = false;
          await this.transference_personnelQueryAll();
        } else {
          throw new Error("การบันทึกล้มเหลว");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึก", "error");
      } finally {
        this.loading = false;
      }
    },

    async changeStatus(tid_ref) {
      try {
        await this.$http.post("transference_personnel.update.php", {
          ApiKey: this.ApiKey,
          id_ref: tid_ref,
          transfer_status: "save"
        });
        this.showSnackbar("เปลี่ยนสถานะเป็น 'บันทึกแล้ว'", "success");
        await this.transference_personnelQueryAll();
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      }
    },

    // ===== FILE MANAGEMENT =====
    async updateFileDoc(tid_ref) {
      await this.fetchPersonDetail(tid_ref);
      this.documentsLinkfiles = null;
      this.documentsLinkfiles3 = null;
      this.updateFileDocdialog = true;
    },

    async updateFileDocSubmit() {
      if (!this.documentsLinkfiles && !this.documentsLinkfiles3) {
        this.showSnackbar("กรุณาเลือกไฟล์อย่างน้อย 1 รายการ", "warning");
        return;
      }

      this.uploadingFile = true;
      try {
        let person = this.transference_personnels_id_ref;
        let updatePayload = {
          ApiKey: this.ApiKey,
          id_tfp: person.id_tfp,
          id_ref: person.tid_ref
        };
        let hasUpdate = false;

        // 1. อัปโหลดเอกสารคำร้อง
        if (this.documentsLinkfiles) {
          let formData = new FormData();
          let filename = `Doc_${person.id_card}_${Date.now()}.pdf`;
          formData.append("ApiKey", this.ApiKey);
          formData.append("file", this.documentsLinkfiles);
          formData.append("filename", "../HRvecfiles/" + filename);

          let res = await this.$http.post("uploadfile.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });

          if (res.data.status) {
            updatePayload.documentsLinkfile = filename;
            hasUpdate = true;
          } else {
            throw new Error("การอัปโหลดเอกสารคำร้องล้มเหลว");
          }
        }

        // 2. อัปโหลดเอกสารคะแนน
        if (this.documentsLinkfiles3) {
          let formData = new FormData();
          let filename = `Score_${person.id_card}_${Date.now()}.pdf`;
          formData.append("ApiKey", this.ApiKey);
          formData.append("file", this.documentsLinkfiles3);
          formData.append("filename", "../HRvecfiles/" + filename);

          let res = await this.$http.post("uploadfile.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });

          if (res.data.status) {
            updatePayload.tpvecprovince_scoreFile = filename;
            hasUpdate = true;
          } else {
            throw new Error("การอัปโหลดเอกสารคะแนนล้มเหลว");
          }
        }

        // 3. บันทึกลงฐานข้อมูล
        if (hasUpdate) {
          let resUpdate = await this.$http.post(
            "transference_personnel.update.php",
            updatePayload
          );

          if (resUpdate.data.status) {
            this.showSnackbar("อัปโหลดไฟล์เรียบร้อย", "success");
            this.updateFileDocdialog = false;
            await this.transference_personnelQueryAll();
          } else {
            throw new Error("บันทึกข้อมูลลงฐานข้อมูลล้มเหลว");
          }
        }
      } catch (error) {
        console.error("Error uploading files:", error);
        this.showSnackbar(
          error.message || "เกิดข้อผิดพลาดในการอัปโหลด",
          "error"
        );
      } finally {
        this.uploadingFile = false;
      }
    },

    viewdocumentsLinkfile(file) {
      this.pdf_files = file;
      this.pdfdocumentsLinkfileDialog = true;
    },

    // ===== DELETE OPERATIONS WITH PASSWORD =====
    async CancelFilePDF(tid_ref) {
      this.currentDeleteAction = "ลบไฟล์เอกสาร";
      this.pendingDeleteCallback = async () => {
        try {
          // 1. ดึงข้อมูลปัจจุบัน
          let res = await this.$http.post("transference_personnel.php", {
            ApiKey: this.ApiKey,
            id_ref: tid_ref
          });
          let currentData = res.data;

          // 2. ลบไฟล์จริง
          if (currentData.documentsLinkfile) {
            await this.$http.post("deletefile.php", {
              ApiKey: this.ApiKey,
              filename: "../HRvecfiles/" + currentData.documentsLinkfile
            });
          }

          // 3. อัปเดตฐานข้อมูล
          let updateRes = await this.$http.post(
            "transference_personnel.update.php",
            {
              ApiKey: this.ApiKey,
              id_tfp: currentData.id_tfp,
              documentsLinkfile: "",
              ccDocumentFile: "",
              comment_dr_c: "",
              detail_comment: ""
            }
          );

          if (updateRes.data.status) {
            this.showSnackbar("ลบไฟล์เรียบร้อย", "success");
            await this.transference_personnelQueryAll();
          } else {
            throw new Error("การอัปเดตฐานข้อมูลล้มเหลว");
          }
        } catch (error) {
          console.error("Error deleting file:", error);
          this.showSnackbar("เกิดข้อผิดพลาดในการลบไฟล์", "error");
        }
      };
      this.passwordDialog = true;
    },

    async CancelFilePDFProvince(tid_ref) {
      this.currentDeleteAction = "ลบไฟล์คะแนน สอจ.";
      this.pendingDeleteCallback = async () => {
        try {
          // 1. ดึงข้อมูลปัจจุบัน
          let res = await this.$http.post("transference_personnel.php", {
            ApiKey: this.ApiKey,
            id_ref: tid_ref
          });
          let currentData = res.data;

          // 2. ลบไฟล์จริง
          if (currentData.tpvecprovince_scoreFile) {
            await this.$http.post("deletefile.php", {
              ApiKey: this.ApiKey,
              filename: "../HRvecfiles/" + currentData.tpvecprovince_scoreFile
            });
          }

          // 3. อัปเดตฐานข้อมูล
          let updateRes = await this.$http.post(
            "transference_personnel.update.php",
            {
              ApiKey: this.ApiKey,
              id_ref: tid_ref,
              tpvecprovince_scoreFile: ""
            }
          );

          if (updateRes.data.status) {
            this.showSnackbar("ลบไฟล์คะแนนเรียบร้อย", "success");
            await this.transference_personnelQueryAll();
          } else {
            throw new Error("การอัปเดตฐานข้อมูลล้มเหลว");
          }
        } catch (error) {
          console.error("Error deleting score file:", error);
          this.showSnackbar("เกิดข้อผิดพลาดในการลบไฟล์", "error");
        }
      };
      this.passwordDialog = true;
    },

    async deletetpteach(tid_ref) {
      this.currentDeleteAction = "ลบรายการผู้ขอย้าย";
      this.pendingDeleteCallback = async () => {
        this.loading = true;
        try {
          let res = await this.$http.post("transference_personnel.update.php", {
            ApiKey: this.ApiKey,
            id_tfp: tid_ref,
            ccDocumentFile: "",
            documentsLinkfile: "",
            comment_dr_c: "",
            detail_comment: "",
            tp_steps: "4" // สถานะลบ
          });

          if (res.data.status) {
            this.showSnackbar("ลบข้อมูลเรียบร้อย", "success");
            await this.transference_personnelQueryAll();
          } else {
            throw new Error("ไม่สามารถลบได้ (อาจมีข้อมูลเชื่อมโยง)");
          }
        } catch (error) {
          console.error("Error deleting record:", error);
          this.showSnackbar(error.message || "เกิดข้อผิดพลาดในการลบ", "error");
        } finally {
          this.loading = false;
        }
      };
      this.passwordDialog = true;
    },

    async clearRecordDontSave() {
      this.currentDeleteAction = "ลบรายการขยะทั้งหมด";
      this.pendingDeleteCallback = async () => {
        this.loading = true;
        try {
          let res = await this.$http.post(
            "transference_personnel.delete_unsaved.php",
            {
              ApiKey: this.ApiKey,
              time_s: this.periods.period_times,
              year_s: this.periods.period_year
            }
          );

          if (res.data.status) {
            this.showSnackbar(
              `ลบรายการขยะเรียบร้อย (${res.data.affected_rows || 0} รายการ)`,
              "success"
            );
            await this.transference_personnelQueryAll();
          } else {
            this.showSnackbar("ไม่พบรายการขยะ", "info");
          }
        } catch (error) {
          console.error("Error clearing records:", error);
          this.showSnackbar("เกิดข้อผิดพลาดในการลบ", "error");
        } finally {
          this.loading = false;
        }
      };
      this.passwordDialog = true;
    },

    async optimizeData() {
      this.currentDeleteAction = "จัดระเบียบฐานข้อมูล";
      this.pendingDeleteCallback = async () => {
        this.loading = true;
        try {
          let res = await this.$http.post("transference_update_admin.php", {
            ApiKey: this.ApiKey,
            time_s: this.periods.period_times,
            year_s: this.periods.period_year
          });
          console.log(res.data);
          if (res.data.status) {
            this.showSnackbar(
              `จัดระเบียบข้อมูลเรียบร้อย (แก้ไขไป ${res.data.affected_rows ||
                0} รายการ)`,
              "success"
            );
            await this.transference_personnelQueryAll();
          } else {
            this.showSnackbar("ไม่พบความผิดปกติของข้อมูล", "info");
          }
        } catch (error) {
          console.error("Error optimizing data:", error);
          this.showSnackbar("เกิดข้อผิดพลาดในการจัดระเบียบ", "error");
        } finally {
          this.loading = false;
        }
      };
      this.passwordDialog = true;
    },

    // ===== PASSWORD VERIFICATION =====
    verifyPassword() {
      this.passwordError = "";

      if (this.passwordInput === this.ADMIN_PASSWORD) {
        // รหัสผ่านถูกต้อง
        this.passwordDialog = false;
        if (this.pendingDeleteCallback) {
          this.pendingDeleteCallback();
          this.pendingDeleteCallback = null;
        }
        this.passwordInput = "";
      } else {
        // รหัสผ่านผิด
        this.passwordError = "รหัสผ่านไม่ถูกต้อง";
        this.showSnackbar("รหัสผ่านไม่ถูกต้อง", "error");
      }
    },

    cancelPasswordVerification() {
      this.passwordDialog = false;
      this.passwordInput = "";
      this.passwordError = "";
      this.pendingDeleteCallback = null;
      this.showSnackbar("ยกเลิกการดำเนินการ", "info");
    },

    // ===== RECEIPT MANAGEMENT =====
    async actionReceipts(id_tfp) {
      try {
        let res = await this.$http.post("transference_personnel.update.php", {
          ApiKey: this.ApiKey,
          id_tfp: id_tfp,
          tp14receipt: "success"
        });

        if (res.data.status) {
          this.showSnackbar("รับเรื่องเรียบร้อย", "success");
          await this.transference_personnelQueryAll();
        } else {
          throw new Error("การบันทึกล้มเหลว");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      }
    },

    async actionReceiptUpdate(id_tfp) {
      try {
        let res = await this.$http.post("transference_personnel.update.php", {
          ApiKey: this.ApiKey,
          id_tfp: id_tfp,
          tp14receipt: ""
        });

        if (res.data.status) {
          this.showSnackbar("ยกเลิกสถานะเรียบร้อย", "success");
          await this.transference_personnelQueryAll();
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      }
    },

    // ===== SCORE UPDATE =====
    async updateScore1420(id_tfp, score) {
      if (isNaN(score) || score < 0 || score > 100) {
        this.showSnackbar("กรุณาระบุคะแนนระหว่าง 0-100", "warning");
        return;
      }

      try {
        let res = await this.$http.post("transference_personnel.update.php", {
          ApiKey: this.ApiKey,
          id_tfp: id_tfp,
          score_1420: parseFloat(score)
        });

        if (res.data.status) {
          // อัปเดตแบบ silent (ไม่แสดง snackbar)
          // this.showSnackbar("บันทึกคะแนนเรียบร้อย", "success");
        } else {
          this.showSnackbar("บันทึกคะแนนล้มเหลว", "error");
        }
      } catch (error) {
        this.showSnackbar("เชื่อมต่อเซิร์ฟเวอร์ไม่ได้", "error");
      }
    },

    // ===== EXCEL EXPORT =====
    exportToExcel() {
      try {
        const data = this.transference_personnels.map(item => ({
          "ชื่อ-นามสกุล": item.personnel_name || "-",
          เลขบัตรประชาชน: item.id_card || "-",
          สถานศึกษาปัจจุบัน: item.college_name || "-",
          เลขที่ตำแหน่ง: item.id_position || "-",
          จังหวัด: item.province_name || "-",
          สถานะการบันทึก:
            item.transfer_status === "save" ? "บันทึกแล้ว" : "ยังไม่บันทึก",
          ปลายทางที่ได้: item.college_name_suss || "-",
          เลขที่ตำแหน่งใหม่: item.id_position_new || "-",
          "ความเห็น ผอ.": this.getCommentText(item.comment_dr_c),
          "ความเห็น สอจ.": this.getCommentText(item.tp_comment_dr_stb),
          สถานะเอกสาร: this.getDocumentStatusText(item.status_document),
          "คะแนน กก.": item.score_1420 || 0,
          รับเรื่อง: item.tp14receipt === "success" ? "รับแล้ว" : "ยังไม่รับ"
        }));

        const ws = XLSX.utils.json_to_sheet(data);

        // ตั้งค่าความกว้างคอลัมน์
        const wscols = [
          { wch: 30 }, // ชื่อ
          { wch: 15 }, // เลขบัตร
          { wch: 35 }, // สถานศึกษา
          { wch: 15 }, // เลขที่ตำแหน่ง
          { wch: 20 }, // จังหวัด
          { wch: 15 }, // สถานะ
          { wch: 35 }, // ปลายทาง
          { wch: 15 }, // เลขที่ใหม่
          { wch: 12 }, // ความเห็น ผอ.
          { wch: 12 }, // ความเห็น สอจ.
          { wch: 12 }, // สถานะเอกสาร
          { wch: 10 }, // คะแนน
          { wch: 10 } // รับเรื่อง
        ];
        ws["!cols"] = wscols;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Personnel_Transfer");

        const filename = `รายการขอย้าย_${this.periods.period_times}_${this.periods.period_year}_${this.time_stamp}.xlsx`;
        XLSX.writeFile(wb, filename);

        this.showSnackbar("ส่งออกไฟล์ Excel เรียบร้อย", "success");
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการส่งออก", "error");
      }
    },

    // ===== HELPER FUNCTIONS =====
    showSnackbar(text, color = "info") {
      const iconMap = {
        success: "mdi-check-circle",
        error: "mdi-alert-circle",
        warning: "mdi-alert",
        info: "mdi-information"
      };

      this.snackbar = {
        show: true,
        text,
        color,
        icon: iconMap[color] || "mdi-information"
      };
    },

    getCommentColor(status) {
      const colorMap = {
        approp: "success",
        inapprop: "warning",
        suspend: "error"
      };
      return colorMap[status] || "grey";
    },
    getCommentText(status) {
      const textMap = {
        approp: "เห็นควร",
        inapprop: "ไม่เห็นควร",
        suspend: "ระงับ"
      };
      return textMap[status] || "รอความเห็น";
    },
    getDocumentStatusText(status) {
      const textMap = {
        complete: "สมบูรณ์",
        incomplete: "ไม่สมบูรณ์",
        do_not: "ไม่ส่ง"
      };
      return textMap[status] || "-";
    }
  }
};
</script>
<style scoped>
/* ===== TABLE STYLES ===== */
.custom-table >>> thead th {
  background-color: #f1f5f9 !important;
  color: #475569 !important;
  font-weight: 600;
  white-space: nowrap;
  font-size: 0.875rem;
}
.custom-table >>> tbody tr:hover {
  background-color: #f8fafc !important;
}
.custom-table >>> tbody td {
  font-size: 0.875rem;
} /* ===== UTILITY CLASSES ===== */
.shadow-sm {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}
.bg-light-blue {
  background-color: #e3f2fd;
}
.bg-white {
  background-color: white !important;
}
.pointer,
.cursor-pointer {
  cursor: pointer;
} /* ===== CARD HOVER EFFECTS ===== */
.v-card.cursor-pointer {
  transition: all 0.3s ease;
}
.v-card.cursor-pointer:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15) !important;
} /* ===== CHIP STYLES ===== */
.v-chip.cursor-pointer:hover {
  opacity: 0.8;
  transform: scale(1.05);
  transition: all 0.2s ease;
} /* ===== DIALOG ANIMATIONS ===== */
.v-dialog {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
} /* ===== TOOLBAR STYLES ===== */
.v-toolbar {
  border-bottom: 3px solid rgba(255, 255, 255, 0.2) !important;
} /* ===== INPUT FOCUS STYLES ===== */
.v-text-field--outlined >>> fieldset {
  border-color: rgba(0, 0, 0, 0.23);
}
.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(0, 0, 0, 0.87);
}
.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-width: 2px;
} /* ===== BUTTON HOVER EFFECTS ===== */
.v-btn {
  transition: all 0.2s ease;
}
.v-btn:hover {
  transform: translateY(-1px);
} /* ===== SCROLLBAR STYLES ===== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: #f1f5f9;
}
::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
} /* ===== LOADING OVERLAY ===== */
.v-data-table__wrapper {
  position: relative;
} /* ===== RESPONSIVE ADJUSTMENTS ===== */
@media (max-width: 960px) {
  .v-card-title.headline {
    font-size: 1.25rem !important;
  }
  .custom-table >>> thead th {
    font-size: 0.75rem;
  }
  .custom-table >>> tbody td {
    font-size: 0.75rem;
  }
} /* ===== PRINT STYLES ===== */
@media print {
  .v-toolbar,
  .v-btn,
  .v-chip.cursor-pointer {
    display: none !important;
  }
}
</style>
